import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RestApiService } from '../rest-api.service';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { MessageService } from '../message.service';
import { RoleActionComponent } from '../role-action/role-action.component';
import { NotifierService } from 'angular-notifier';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, OnDestroy {

    public opened = true;
    public isUserCollapsed = true;
    public isLanCollapsed = true;
    navbar = [];
    public userName: string;
    mobileQuery: MediaQueryList;
    respObject: any;
    // private eventUrl: string;
    private _mobileQueryListener: () => void;
    clientId: number;
    navLoaded = true;
    roleName: string;
    copyYear: number;
    @ViewChild('content') myModal: any;
    Newpassword: string;
    confirmpassword: string;
    password: string;
    dialogRef: any;
    private notifier: NotifierService;

    constructor(private _rest: RestApiService, private messageService: MessageService,
        private actRoute: ActivatedRoute, private route: Router, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, public dialog: MatDialog, notifier: NotifierService) {
        this.notifier = notifier;
        this.mobileQuery = media.matchMedia('(max-width: 600px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);
        // console.log(' routing ---');
        //this.messageService.clientId = undefined;
        console.log('inside');
        route.events.subscribe((event) => {

            if (event instanceof NavigationStart) {
                // Show loading indicator
                // console.log('NavigationStart');
            }

            if (event instanceof NavigationEnd) {
                // console.log('end : ' + JSON.stringify(event));
                // console.log('NavigationEnd');
                // this.eventUrl = event.url;
                // this.messageService.getModules();
                //  console.log(JSON.stringify(window.location.href));

                if (this.messageService.getUserId() !== null) {
                    this._rest.getUrlSequence({ user_id: this.messageService.getUserId(), url: window.location.href }).subscribe((res) => {
                        this.respObject = res;
                        if (this.respObject.success) {
                            // console.log(JSON.stringify(this.respObject));
                            // this.messageService.setUserAuth(this.respObject.details);
                            if (this.respObject.details.length === 2) {
                                // console.log('----->' + this.respObject.details[0].url, this.respObject.details[1].url);
                                this.messageService.urlPathSubject.next({
                                    prevPath: this.respObject.details[0].url,
                                    nextPath: this.respObject.details[1].url
                                });
                            }
                            if (this.respObject.details.length === 1) {
                                if (this.respObject.details[0].previous) {
                                    this.messageService.urlPathSubject.next({ prevPath: this.respObject.details[0].url });
                                } else {
                                    this.messageService.urlPathSubject.next({ nextPath: this.respObject.details[0].url });
                                }
                            }

                        } else {

                        }
                    }, (err) => {

                    });
                }
                // Hide loading indicator
            }

            if (event instanceof NavigationError) {
                // Hide loading indicator
                // Present error to user
                // console.log(event.error);
            }
        });
    }

    getRoleAndDetails() {
        this.navLoaded = false;
        console.log('clientCode === >>> ' + this.messageService.clientCode);
        console.log('clientid === >>> ' + this.messageService.clientId);
        this._rest.getRoleUserActionMapping({ user_id: this.messageService.getUserId(), url: window.location.href }).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                // console.log(JSON.stringify(this.respObject));

                this.userName = this.respObject.details.name;
                this.clientId = this.respObject.details.clientId;
                this.messageService.setClientId(this.clientId);
                const isAdmin = this.respObject.details.actionDtls[0].isAdmin;
                // this.respObject.details.actionDtls[0].clientId = this.respObject.details.clientId;
                this.roleName = this.respObject.details.actionDtls[0].roleName;
                const urls = this.respObject.details.urls;
                for (let i = 0; i < urls.length; i++) {
                    if (urls[i].name === 'logout') {
                        this.messageService.logOutUrl = urls[i].url;
                    }
                    if (urls[i].name === 'search') {
                        this.messageService.searchUrl = urls[i].url;
                    }
                    if (urls[i].name === 'dashboard' && urls[i].isAdmin === isAdmin) {
                        this.messageService.dashboardUrl = urls[i].url;
                    }
                    if (urls[i].name === 'faq') {
                        this.messageService.faqUrl = urls[i].url;
                    }
                    if (urls[i].name === 'bulkAssigment') {
                        this.messageService.bulkAssigmentUrl = urls[i].url;
                    }
                }
                this._rest.getDynamicMenuDtls(this.clientId, this.messageService.getUserId()).subscribe((res1) => {
                    this.respObject = res1;
                    // console.log(JSON.stringify(this.respObject));
                    if (this.respObject.success) {
                        this.navbar = this.respObject.details;
                        this.navLoaded = true;
                    } else {
                    }
                }, (err) => {

                });
                this.messageService.setClientUserAuth(this.respObject.details.actionDtls);
                // this.messageService.setUserAuth(this.respObject.details.actionDtls);
            } else {
                alert(this.respObject.errorMessage);
                this.messageService.logOut();
            }
        }, (err) => {

        });
    }

    ngOnInit() {
        this.copyYear = new Date().getFullYear();
        console.log('inside navbar');
        this.actRoute.queryParams.subscribe(params => {
            const client = params['clientId'];
            if (client === undefined) {

            } else {
                this.messageService.setClientId(client);
            }

        });
        console.log(this.messageService.getUserId() + ' ======== ' + this.messageService.getclientId());
        if (this.messageService.getUserId() !== null) {
            this.getRoleAndDetails();
        }


    }

    ngOnDestroy(): void {
        this.mobileQuery.removeListener(this._mobileQueryListener);
    }

    langCollapse() {
        this.isLanCollapsed = !this.isLanCollapsed;
        this.isUserCollapsed = true;
    }

    userCollapse() {
        this.isUserCollapsed = !this.isUserCollapsed;
        this.isLanCollapsed = true;
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }


    signOut() {
        // this.messageService.clearSession();
        // window.location.href = this.messageService.API_ROOT;
        this.messageService.logOut();
    }

    change_password() {
        this.dialogRef = this.dialog.open(this.myModal, {});
    }

    submit() {
        const pattern = /^[a-zA-Z0-9!@#$%^&*]{8,20}$/;
        if (!this.Newpassword.match(pattern)) {
            this.notifier.notify('error', ' Invalid Password ');
        } else {
            if (this.Newpassword == this.confirmpassword) {
                // alert('matched');
                const data = {
                    password: this.password,
                    newPassword: this.confirmpassword,
                    clientId: this.clientId
                };
                // console.log('================'+JSON.stringify(data));
                this._rest.PasswordChange(data).subscribe((res1) => {
                    this.respObject = res1;
                    if (this.respObject.success) {

                        alert('To make sure your account\'s secure ,we can log you out of any other devices, ' +
                            'you can log back in with your New Password');
                        // this.notifier.notify('success','Password changed');
                        this.messageService.logOut();
                        // console.log('============================= > password changed')
                    } else {
                        this.notifier.notify('error', this.respObject.errorMessage);
                    }
                }, (err) => {
                    this.notifier.notify('error', this.messageService.SERVER_ERROR);
                });


            } else {
                this.notifier.notify('error', 'New Password and Confirm Password are not matched');
            }
        }

    }

    onNoClick() {
        this.dialogRef.close();
    }

    changeToDashboard() {
        if (this.messageService.dashboardUrl !== undefined && this.messageService.dashboardUrl !== null) {
            this.messageService.changeRouting(this.messageService.dashboardUrl);
        }
    }


}
